if (!customElements.get('product-style')) {
  class ProductStyles extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.addEventListener('change', (event) => {
        const target = event.target
        const label = target.parentNode
        const isClearance = target.classList.contains('js-is-clearance')
        if (isClearance) {
          document.querySelector('product-info').dataset.productClearance = 'true'
        } else {
          document.querySelector('product-info').dataset.productClearance = 'false'
        }
        if (label) {
          label.classList.add('loading')
          label.querySelector('.loading__spinner')?.classList.remove('hidden')
        }
        publish(PUB_SUB_EVENTS.onStyleChange, {
          data: {
            event,
            target,
          },
        })
      })
    }
  }
  customElements.define('product-style', ProductStyles)
}

if (!customElements.get('product-type-selector')) {
  class ProductTypeSelector extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.addEventListener('change', (event) => {
        const target = event.target
        const isClearance = target.classList.contains('js-is-clearance')
        if (isClearance) {
          document.querySelector('product-info').dataset.productClearance = 'true'
        } else {
          document.querySelector('product-info').dataset.productClearance = 'false'
        }
        const label = target.parentNode
        if (label) {
          label.classList.add('loading')
          label.querySelector('.loading__spinner')?.classList.remove('hidden')
        }
        publish(PUB_SUB_EVENTS.onTypeChange, {
          data: {
            event,
            target,
          },
        })
      })
    }
  }
  customElements.define('product-type-selector', ProductTypeSelector)
}

if (!customElements.get('product-pack-selector')) {
  class ProductPackSelector extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.addEventListener('change', (event) => {
        const target = event.target
        const isClearance = target.classList.contains('js-is-clearance')
        if (isClearance) {
          document.querySelector('product-info').dataset.productClearance = 'true'
        } else {
          document.querySelector('product-info').dataset.productClearance = 'false'
        }
        const label = target.parentNode
        if (label) {
          label.classList.add('loading')
          label.querySelector('.loading__spinner')?.classList.remove('hidden')
        }
        publish(PUB_SUB_EVENTS.onPackSizeChange, {
          data: {
            event,
            target,
          },
        })
      })
    }
  }
  customElements.define('product-pack-selector', ProductPackSelector)
}

if (!customElements.get('product-info')) {
  class ProductInfo extends HTMLElement {
    onVariantChangeUnsubscriber = undefined
    onStyleChangeUnsubscriber = undefined
    onPackColorsChangeUnsubscriber = undefined
    onPackChangeUnsubscriber = undefined
    onTypeChangeUnsubscriber = undefined
    abortController = null
    responseCache = new Map() // Cache to store responses
    preProcessHtmlCallbacks = []
    postProcessHtmlCallbacks = []

    constructor() {
      super()
    }

    connectedCallback() {
      this.onVariantChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.optionValueSelectionChange,
        this.handleOptionValueChange.bind(this),
      )
      this.onStyleChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.onStyleChange,
        this.handleStyleChange.bind(this),
      )
      this.onPackColorsChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.onPackColorsChange,
        this.handleProductChange.bind(this),
      )
      this.onPackChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.onPackSizeChange,
        this.handlePackSizeChange.bind(this),
      )
      this.onTypeChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.onTypeChange,
        this.handleTypeChange.bind(this),
      )
    }

    handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
      if (!this.contains(event.target)) return

      // Update the corresponding size display
      const optionGroup = target.closest('.pdp__variant-selector-buttons')
      if (optionGroup) {
        const header = optionGroup.previousElementSibling
        if (header) {
          const sizeDisplay = header.querySelector('.js-selected-size-display')
          if (sizeDisplay) {
            if (target.value === 'S') {
              sizeDisplay.textContent = 'Small'
            } else if (target.value === 'M') {
              sizeDisplay.textContent = 'Medium'
            } else if (target.value === 'L') {
              sizeDisplay.textContent = 'Large'
            } else if (target.value === 'XL') {
              sizeDisplay.textContent = 'X-Large'
            } else if (target.value === '2XL') {
              sizeDisplay.textContent = '2X-Large'
            } else if (target.value === '3XL') {
              sizeDisplay.textContent = '3X-Large'
            } else if (target.value === '4XL') {
              sizeDisplay.textContent = '4X-Large'
            } else {
              sizeDisplay.textContent = target.value
            }
          }
        }
      }

      this.updateFormState()
      if (this.dataset.isVarietyPacks === 'true') return
    }

    handleStyleChange({ data: { event, target } }) {
      if (!this.contains(event.target)) return

      const productUrl = target.value
      const variantId = this.keepSize(productUrl)

      this.renderProductInfo({
        requestUrl: this.buildRequestUrlWithParams(productUrl, [], false, variantId),
        callback: this.handleUpdateFullProductInfo(productUrl, 'style'),
      })
    }

    handleTypeChange({ data: { event, target } }) {
      if (!this.contains(event.target)) return

      const productUrl = target.value
      const variantId = this.keepSize(productUrl, target.dataset.size)

      this.renderProductInfo({
        requestUrl: this.buildRequestUrlWithParams(productUrl, [], false, variantId),
        callback: this.handleUpdateFullProductInfo(productUrl),
      })
    }

    handleProductChange({ data: { event, target } }) {
      if (!this.contains(event.target)) return

      const productId = Number(target.dataset.productId)
      const selectedSize = this.dataset.selectedSize
      let productFound = this.jsonData.packs_data_json.find((product) => product.id === productId)
      if (!productFound) {
        productFound = this.jsonData.singles_data_json.find((product) => product.id === productId)
      }
      if (!productFound) return

      this.dataset.productId = Number(target.dataset.productId)
      this.dataset.productHandle = target.value
      this.dataset.colorPack = target.dataset.colorPack

      if (target.classList.contains('js-is-clearance')) {
        this.dataset.productClearance = true
      } else {
        this.dataset.productClearance = false
      }

      if (this.dataset.isVarietyPacks == 'true') {
        this.updateProductTitleFromJsonData(productFound)
      }

      // Update product price with input data
      this.updateProductPriceFromInputData(target)

      // Update color list
      this.updateColorList(target.dataset.colorList)

      // Update gallery slides
      this.updateGallery(productFound)

      this.updateProductVariantsFromJsonData(productFound, selectedSize)

      const productUrl = target.value
      const variantId = this.keepSize(productUrl)

      this.renderProductInfo({
        requestUrl: this.buildRequestUrlWithParams(productUrl, [], false, variantId),
        callback: this.handleDataUpdate(),
      })

      this.updateFormState(productFound)
      this.sendDataLayerInfo()
    }

    handlePackSizeChange({ data: { event, target } }) {
      if (!this.contains(event.target)) return

      const productUrl = target.value
      this.dataset.productPackSize = target.dataset.size
      const variantId = this.keepSize(productUrl)

      this.renderProductInfo({
        requestUrl: this.buildRequestUrlWithParams(productUrl, [], false, variantId),
        callback: this.handleUpdateFullProductInfo(productUrl),
      })
    }

    renderProductInfo({ requestUrl, callback }) {
      this.abortController?.abort()
      this.abortController = new AbortController()

      // Check if we have a cached response
      if (this.responseCache.has(requestUrl)) {
        const cachedHtml = this.responseCache.get(requestUrl)
        callback(cachedHtml)
        return
      }

      fetch(requestUrl, { signal: this.abortController.signal })
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          // Store the parsed HTML in cache
          this.responseCache.set(requestUrl, html)
          callback(html)
        })
        .catch((error) => {
          if (error.name === 'AbortError') {
            console.log('Fetch aborted by user')
            this.querySelectorAll('label').forEach((label) => {
              label.classList.remove('loading')
            })
            this.querySelectorAll('.loading__spinner').forEach((spinner) => {
              spinner.classList.add('hidden')
            })
          } else {
            console.error(error)
          }
        })
    }

    handleDataUpdate() {
      // this.querySelector('product-form-v2').classList.add('loading')
      return (html) => {
        const updates = [
          () => (this.dataset.isVarietyPacks == 'false' ? this.updateProductTitle(html) : null),
          () => (this.dataset.isVarietyPacks == 'true' ? this.updateProductPrice(html) : null),
          () => (this.dataset.isVarietyPacks == 'true' ? this.updateProductStarRating(html) : null),
          () => this.dataset.isVarietyPacks == 'true' ? this.updateProductDescription(html) : null,
          () => this.updatePdpProductContext(html),
          () => this.updateProductInfoData(html),
          // () => this.sendDataLayerInfo(),
          () => this.updateSizeChartButton(html),
          () => this.updateSizeChartModal(html),
        ]

        // Execute all updates
        updates.forEach((update) => update())
        // this.querySelector('product-form-v2').classList.remove('loading')

        // Update view full details link on quick add modal
        const viewFullDetails = document.querySelector('.js-quick-modal-view-full-details')
        if (viewFullDetails) {
          viewFullDetails.href = this.dataset.url
        }

        // Update carousel video if exists inside json data
        if (this.dataset.productPackSize === 'Single') {
          const carouselVideo = this.querySelector('product-gallery .js-carousel-video video')
          if (this.jsonData.carousel_videos.carousel_video && carouselVideo) {
            this.querySelector('product-gallery .js-carousel-video').style.display = 'block'
            carouselVideo.src = this.jsonData.carousel_videos.carousel_video.sources[0].url
            carouselVideo.load()
          } else {
            this.querySelector('product-gallery .js-carousel-video').style.display = 'none'
          }
        }
      }
    }

    handleUpdateFullProductInfo(productUrl, updateType = '') {
      this.querySelector('product-form-v2').classList.add('loading')
      return (html) => {
        const variant = this.getSelectedVariant(html)

        const updates = [
          () => this.updateURL(productUrl, variant?.id),
          () => this.updateProductTitle(html),
          () => this.updateProductPrice(html),
          () => (updateType === 'style' ? this.updateProductStarRating(html) : null),
          () => this.updateMonocleProductPrice(html),
          () => this.updateTypeSelector(html),
          () => this.updateOptionValues(html),
          () => this.updateVariantInputs(variant?.id),
          () => this.updateTallEquivalent(html),
          () => this.updateStyleSelector(html),
          () => this.updateColors(html),
          () => this.updateProductForm(html),
          () => this.updateProductCustomPack(html),
          () => this.updatePackSelectors(html),
          () => this.updateProductGalleryFromHtml(html),
          () => this.updateUiFooter(html),
          () => this.updateBxgy(html),
          () => this.updateBelowPdpAppContent(html),
          () => this.updatePdpProductContext(html),
          () => this.updateProductInfoData(html),
          () => this.sendDataLayerInfo(),
          () => this.updateSizeChartButton(html),
          () => this.updateSizeChartModal(html),
          () => (updateType === 'style' ? this.updateOkendoReviews() : null),
        ]

        updates.forEach((update) => update())
        this.querySelector('product-form-v2').classList.remove('loading')

        // Update view full details link on quick add modal
        const viewFullDetails = document.querySelector('.js-quick-modal-view-full-details')
        if (viewFullDetails) {
          viewFullDetails.href = this.dataset.url
        }
      }
    }

    findVariantFromOptions(selectedValues) {
      const productId = Number(this.dataset.productId)
      let productFound = this?.jsonData?.packs_data_json.find((product) => product.id === productId)
      if (!productFound) {
        productFound = this?.jsonData?.singles_data_json.find((product) => product.id === productId)
      }
      if (!productFound) return null

      return productFound.variants.find((variant) => {
        return selectedValues.every((value, index) => {
          return variant[`option${index + 1}`] === value
        })
      })
    }

    updateProductVariantsFromJsonData(productFound, selectedSize) {
      // Recreate variant selectors based on product options
      const variantSelects = this.querySelector('variant-selects')
      if (variantSelects && productFound.options && productFound.variants) {
        // Get the existing structure
        const existingContent = variantSelects.innerHTML

        // Create a temporary container to parse the existing content
        const tempContainer = document.createElement('div')
        tempContainer.innerHTML = existingContent

        // Get all headers and button groups
        let variantSelectorHeaders = tempContainer.querySelectorAll(
          '.pdp__variant-selector-header',
        )
        let variantSelectorGroups = tempContainer.querySelectorAll(
          '.pdp__variant-selector-buttons',
        )

        // If we need more option groups than we currently have, create them
        if (productFound.options.length > variantSelectorHeaders.length) {
          // Get the first header and group as templates
          const templateHeader = variantSelectorHeaders[0]
          const templateGroup = variantSelectorGroups[0]

          if (templateHeader && templateGroup) {
            // Create missing headers and groups
            for (let i = variantSelectorHeaders.length; i < productFound.options.length; i++) {
              // Clone and modify header
              const newHeader = templateHeader.cloneNode(true)
              const headerTitle = newHeader.querySelector('h3 strong')
              if (headerTitle) {
                headerTitle.textContent = `${productFound.options[i]}:`
              }
              const sizeDisplay = newHeader.querySelector('.js-selected-size-display')
              if (sizeDisplay) {
                sizeDisplay.textContent = 'Choose your size.'
              }

              // For non-first options, remove size chart buttons if they exist
              if (i > 0) {
                const sizeOptionsWrapper = newHeader.querySelector('.size-options-wrapper')
                if (sizeOptionsWrapper) {
                  sizeOptionsWrapper.remove()
                }
              }

              // Clone button group
              const newGroup = templateGroup.cloneNode(true)
              newGroup.innerHTML = '' // Clear any existing buttons

              // Add new elements to the container
              templateHeader.parentNode.appendChild(newHeader)
              templateGroup.parentNode.appendChild(newGroup)
            }
          }
        } else {
          // Remove extra headers and groups that aren't needed for this product
          for (let i = productFound.options.length; i < variantSelectorHeaders.length; i++) {
            variantSelectorHeaders[i].remove()
            if (variantSelectorGroups[i]) {
              variantSelectorGroups[i].remove()
            }
          }
        }

        // Get updated NodeLists after modifications
        variantSelectorGroups = tempContainer.querySelectorAll(
          '.pdp__variant-selector-buttons',
        )

        // Get the currently selected values from existing checked inputs
        const selectedValues = Array.from(variantSelects.querySelectorAll('input:checked')).map(
          (input) => input.value,
        )

        // Get unique values for each option from variants
        const optionValues = productFound.options.map((option, index) => {
          const optionNumber = index + 1
          const values = new Set()
          productFound.variants.forEach((variant) => {
            if (variant[`option${optionNumber}`]) {
              values.add(variant[`option${optionNumber}`])
            }
          })
          return {
            name: option,
            position: index + 1,
            values: Array.from(values),
          }
        })

        // Ensure we have a group for each option
        if (variantSelectorGroups.length === productFound.options.length) {
          // Create selectors for each option in their respective groups
          optionValues.forEach((option, optionIndex) => {
            const selectorGroup = variantSelectorGroups[optionIndex]
            if (!selectorGroup) return

            // Clear the group before adding new buttons
            selectorGroup.innerHTML = ''

            option.values.forEach((value, valueIndex) => {
              const inputId = `${this.dataset.section}-${option.position}-${valueIndex}`
              const inputName = `${option.name}-${option.position}`

              // Find if this variant combination is available
              const variantAvailable = productFound.variants.some((variant) => {
                const matchesOption = variant[`option${option.position}`] === value
                // For the first option (usually Size), we only check that option
                if (option.position === 1) {
                  return matchesOption && variant.available
                }
                // For other options, we need to match the selected values of previous options
                const previousOptionsMatch = optionValues
                  .slice(0, optionIndex)
                  .every((prevOption, prevIndex) => {
                    const selectedValue = variantSelects.querySelector(
                      `input[name="${prevOption.name}-${prevOption.position}"]:checked`,
                    )?.value
                    return selectedValue && variant[`option${prevIndex + 1}`] === selectedValue
                  })
                return matchesOption && previousOptionsMatch && variant.available
              })

              const label = document.createElement('label')
              label.setAttribute('for', inputId)
              label.textContent = value

              const input = document.createElement('input')
              input.classList.add('visually-hidden')
              if (!variantAvailable) {
                input.classList.add('disabled')
              }
              input.type = 'radio'
              input.id = inputId
              input.name = inputName
              input.value = value
              input.setAttribute('form', `product-form-v2-${this.dataset.section}`)
              input.dataset.productHandle = productFound.handle
              input.dataset.productId = productFound.id

              // Check if this is the selected value for this option
              if (selectedValues[optionIndex] === value) {
                input.checked = true
              }

              label.appendChild(input)
              selectorGroup.appendChild(label)
            })
          })
        }

        variantSelects.innerHTML = tempContainer.innerHTML

        // Update the variant selects content while preserving structure
        const variantGroups = this.querySelectorAll('.pdp__variant-selector-buttons')
        const selectedOptions = selectedSize.split(' / ')

        if (selectedSize === '') {
          this.updateURL(this.dataset.productHandle, '')
          return
        }
        selectedOptions.forEach((option, index) => {
          const variantGroup = variantGroups[index]
          if (variantGroup) {
            const optionInput = variantGroup.querySelector(`input[value="${option}"]`)
            if (optionInput) {
              optionInput.checked = true
            }
          }
        })
      }
    }

    updateFormState(productFound) {
      const variantSelects = this.querySelector('variant-selects')
      if (!variantSelects) return

      // Get all required options
      const optionGroups = variantSelects.querySelectorAll(
        'variant-selects .pdp__variant-selector-buttons',
      )

      // Update dataset.selectedSize with all selected values
      const selectedInputs = Array.from(optionGroups)
        .map((group) => group.querySelector('input:checked'))
        .filter((input) => input !== null)
        .map((input) => input.value)

      this.dataset.selectedSize = selectedInputs.join(' / ')

      // Update form inputs
      if (this.dataset.productPackSize === 'Single') {
        if (this.dataset.productClearance === 'true') {
          const form = this.querySelector('product-form-v2 form')
          // Remove any existing property inputs first
          form.querySelectorAll('input[name^="properties[_"]').forEach((input) => input.remove())

          // Add clearance-specific hidden inputs
          const clearanceInput = document.createElement('input')
          clearanceInput.type = 'hidden'
          clearanceInput.name = 'properties[_clearance]'
          clearanceInput.value = 'true'

          const typeInput = document.createElement('input')
          typeInput.type = 'hidden'
          typeInput.name = 'properties[_type]'
          typeInput.value = 'PDP'

          const preClearanceInput = document.createElement('input')
          preClearanceInput.type = 'hidden'
          preClearanceInput.name = 'properties[_pre_clearance_price]'
          preClearanceInput.value = this.dataset.compareAtPrice || ''

          form.appendChild(clearanceInput)
          form.appendChild(typeInput)
          form.appendChild(preClearanceInput)
        } else {
          const form = this.querySelector('product-form-v2 form')
          // Remove any existing property inputs first
          form.querySelectorAll('input[name^="properties[_"]').forEach((input) => input.remove())

          // Add value builder hidden inputs
          const valueBuilderInput = document.createElement('input')
          valueBuilderInput.type = 'hidden'
          valueBuilderInput.name = 'properties[_value_builder]'
          valueBuilderInput.value = 'true'

          const typeInput = document.createElement('input')
          typeInput.type = 'hidden'
          typeInput.name = 'properties[_type]'
          typeInput.value = 'PDP'

          form.appendChild(valueBuilderInput)
          form.appendChild(typeInput)
        }
      } else {
        // Remove all property inputs when not Single
        const form = this.querySelector('product-form-v2 form')
        if (form) {
          form.querySelectorAll('input[name^="properties[_"]').forEach((input) => input.remove())
        }
      }

      const allOptionsSelected = selectedInputs.length === optionGroups.length

      // Update form button
      const submitButton = this.querySelector('product-form-v2 form button[type="submit"]')
      const submitButtonText = submitButton.querySelector('.js-button-text')

      if (!allOptionsSelected) {
        submitButton.disabled = true
        submitButtonText.innerHTML = submitButton.dataset.selectSizeText
        this.updateURL(this.dataset.productHandle, '')
        return
      }

      // If all options are selected, check if the variant exists and is available
      const selectedVariant = this.findVariantFromOptions(selectedInputs)

      if (!selectedVariant) {
        submitButton.disabled = true
        submitButtonText.innerHTML = submitButton.dataset.unavailableText
        this.dataset.productAvailable = false
        return
      }

      this.dataset.variantId = selectedVariant.id
      const formInput = this.querySelector('product-form-v2 form input[name="id"]')
      formInput.value = selectedVariant.id
      formInput.disabled = !selectedVariant.available
      this.updateURL(this.dataset.productHandle, selectedVariant.id)

      this.updateProductInfoDataFromJsonData(productFound, selectedVariant)

      if (!selectedVariant.available) {
        submitButton.disabled = true
        submitButtonText.innerHTML = submitButton.dataset.soldOutText
        this.dataset.productAvailable = false

        // Update Klaviyo form variant ID
        const klaviyoForm = this.querySelector('klaviyo-notify-me')
        if (klaviyoForm) {
          const variantIdInput = klaviyoForm.querySelector('input[name="variant_id"]')
          if (variantIdInput) {
            variantIdInput.value = selectedVariant.id
          }
          const formButton = klaviyoForm.querySelector('button[type="submit"]')
          if (formButton) {
            formButton.dataset.productId = this.dataset.productId
            formButton.dataset.variantId = selectedVariant.id
            formButton.dataset.productTitle = this.dataset.productTitle
            formButton.dataset.productUrl = this.dataset.url
          }
        }
        if (this.dataset.isVarietyPacks == 'false') {
          this.updateProductAvailableState()
        }
        return
      }

      // Enable the button if we have a valid, available variant
      submitButton.disabled = false
      submitButtonText.innerHTML = submitButton.dataset.addToCartText
      this.dataset.productAvailable = true

      if (this.dataset.isVarietyPacks == 'false') {
        this.updateProductAvailableState()
      }
    }

    updateProductAvailableState() {
      const variantSelects = this.querySelector('variant-selects')
      if (!variantSelects) return

      // Get all checked inputs with their names and values
      const selectedOptions = {}
      variantSelects.querySelectorAll('input:checked').forEach((input) => {
        selectedOptions[input.name] = input.value
      })

      // For each color input, check if it has the exact option combination
      this.querySelectorAll('product-colors input').forEach((input) => {
        const colorProductId = Number(input.dataset.productId)
        let productFound = this.jsonData.packs_data_json.find(
          (product) => product.id === colorProductId,
        )
        if (!productFound) {
          productFound = this.jsonData.singles_data_json.find(
            (product) => product.id === colorProductId,
          )
        }
        if (!productFound) return

        const variantFound = productFound.variants.find(
          (variant) => variant.title === this.dataset.selectedSize,
        )
        if (!variantFound) {
          input.classList.add('disabled')
          input.dataset.disabled = 'true'
          return
        }

        const variantAvailable = variantFound.available
        if (variantAvailable) {
          input.classList.remove('disabled')
          input.dataset.disabled = 'false'
        } else {
          input.classList.add('disabled')
          input.dataset.disabled = 'true'
        }
      })

      // Reorder labels within each wrapper based on their input's disabled state
      const productColors = this.querySelector('product-colors')
      if (productColors) {
        const swatchesWrappers = productColors.querySelectorAll(
          '.pdp__product-color-swatches-wrapper',
        )
        swatchesWrappers.forEach((wrapper) => {
          const labels = Array.from(wrapper.querySelectorAll('label'))
          labels.sort((a, b) => {
            const aDisabled = a.querySelector('input').classList.contains('disabled')
            const bDisabled = b.querySelector('input').classList.contains('disabled')
            return Number(aDisabled) - Number(bDisabled)
          })
          labels.forEach((label) => wrapper.appendChild(label))
        })
      }

      handleNotReturningSwatches()
    }

    updateColorList(colorList) {
      console.log({ colorList });
      const colorDisplay = this.querySelector('#color-display')
      if (colorDisplay) {
        colorDisplay.dataset.colorList = colorList
        const productColors = this.querySelector('product-colors')
        if (productColors) {
          productColors.setupToggleColors()
        }
      }
    }

    updateGallery(productFound) {
      const gallery = this.querySelector('product-gallery')
      if (gallery && productFound.media && productFound.media.length > 0) {
        gallery.updateGalleryMedia(productFound.media)
      }
    }

    getSelectedVariant(productInfoNode) {
      const selectedVariant = productInfoNode.querySelector(
        'variant-selects [data-selected-variant]',
      )?.innerHTML
      return !!selectedVariant ? JSON.parse(selectedVariant) : null
    }

    updateOptionValues(html) {
      const variantSelects = html.querySelector('variant-selects')
      if (variantSelects && this.variantSelectors) {
        // Save the size options wrapper before update
        const existingSizeOptions = this.variantSelectors.querySelector('.size-options-wrapper')

        HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, [])

        // If there was a size options wrapper, restore it
        if (existingSizeOptions) {
          const newSizeOptionsWrapper = this.variantSelectors.querySelector('.size-options-wrapper')
          if (newSizeOptionsWrapper) {
            newSizeOptionsWrapper.replaceWith(existingSizeOptions)
          }
        }
      }
    }

    updateColors(html) {
      if (this.dataset.isVarietyPacks == 'true') {
        return
      }
      const productColors = html.querySelector('product-colors')
      if (productColors && this.productColors) {
        HTMLUpdateUtility.viewTransition(this.productColors, productColors, [])
      }
    }

    updateStyleSelector(html) {
      const productStyle = html.querySelector('product-style')
      if (productStyle && this.productStyle) {
        HTMLUpdateUtility.viewTransition(this.productStyle, productStyle, [])
      }
    }

    updateTypeSelector(html) {
      const productType = html.querySelector('product-type-selector')
      if (productType && this.productType) {
        HTMLUpdateUtility.viewTransition(this.productType, productType, [])
      }
    }

    updatePackSelectors(html) {
      const packSelectors = html.querySelector('product-pack-selector')
      if (packSelectors && this.packSelectors) {
        HTMLUpdateUtility.viewTransition(this.packSelectors, packSelectors, [])
      }
    }

    updateProductTitle(html) {
      const productTitle = html.querySelector('.js-product-title')
      if (productTitle && this.productTitle) {
        HTMLUpdateUtility.viewTransition(this.productTitle, productTitle, [])
      }
    }

    updateProductTitleFromJsonData(productFound) {
      const productTitle = this.querySelector('.js-product-title')
      if (productTitle) {
        productTitle.innerHTML = productFound.title
      }
    }

    updateProductInfoDataFromJsonData(productFound = null, selectedVariant = null) {
      if (productFound) {
        this.dataset.productId = productFound.id
        this.dataset.url = `/products/${productFound.handle}`
        this.dataset.productHandle = productFound.handle
        this.dataset.productTitle = productFound.title
      }
      if (selectedVariant) {
        this.dataset.variantId = selectedVariant.id
      }
    }

    updateProductInfoData(html) {
      const productInfo = html.querySelector('product-info')
      if (productInfo) {
        this.dataset.productAvailable = productInfo.dataset.productAvailable
        this.dataset.productPackSize = productInfo.dataset.productPackSize
        this.dataset.membershipStatus = productInfo.dataset.membershipStatus
        this.dataset.customerId = productInfo.dataset.customerId
        this.dataset.colorPack = productInfo.dataset.colorPack
        this.dataset.loginStatus = productInfo.dataset.loginStatus
        this.dataset.packQuantity = productInfo.dataset.packQuantity
        this.dataset.ecommerceCurrency = productInfo.dataset.ecommerceCurrency
        this.dataset.productPrice = productInfo.dataset.productPrice
        this.dataset.productId = productInfo.dataset.productId
        this.dataset.productTitle = productInfo.dataset.productTitle
        this.dataset.productDiscount = productInfo.dataset.productDiscount
        this.dataset.productBrand = productInfo.dataset.productBrand
        this.dataset.productCategory = productInfo.dataset.productCategory
        this.dataset.productCategory2 = productInfo.dataset.productCategory2
        this.dataset.productCategory3 = productInfo.dataset.productCategory3
        this.dataset.productCategory4 = productInfo.dataset.productCategory4
        this.dataset.productCategory5 = productInfo.dataset.productCategory5

        const currencySymbol = productInfo.dataset.currencySymbol
        if (this.insidersPrice) {
          this.insidersPrice.innerHTML = `
            <span class="desktop">Reg <s>${currencySymbol} ${Number(productInfo.dataset.productPrice).toFixed(2)}</s></span>
            <span class="mobile"><s>${currencySymbol} ${Number(productInfo.dataset.productPrice).toFixed(2)}</s></span>
            <strong class="pdp__insider-discount-price desktop">Insiders ${currencySymbol}${productInfo.dataset.membershipPrice}</strong>
            <strong class="pdp__insider-discount-price mobile">${currencySymbol}${productInfo.dataset.membershipPrice}</strong>
          `
        }
        if (this.bxgyPrice) {
          this.bxgyPrice.textContent = `${productInfo.dataset.productPriceFormatted}`;
        }
      }
    }

    updateProductStarRating(html) {
      const productStarRating = html.querySelector('.js-product-star-rating')
      if (productStarRating && this.productStarRating) {
        HTMLUpdateUtility.viewTransition(this.productStarRating, productStarRating, [])
      }
    }

    updateProductPrice(html) {
      const productPrice = html.querySelector('.js-product-price')
      if (productPrice && this.productPrice) {
        HTMLUpdateUtility.viewTransition(this.productPrice, productPrice, [])
      }
    }

    updateMonocleProductPrice(html) {
      const productPrice = Number(html.querySelector('product-info').dataset.productPrice)
      const monocleDiscount = this.querySelector('discount-bar')
      if (!productPrice || !monocleDiscount) return
      const symbol = monocleDiscount.dataset.currencySymbol
      const couponValue = Number(monocleDiscount.dataset.couponValue)
      const newPrice = Math.round(productPrice * couponValue)
      if (this.monocleProductPrice) {
        this.monocleProductPrice.innerHTML = `${symbol}${newPrice}`
      }
    }

    updateProductForm(html) {
      const productForm = html.querySelector('product-form-v2')
      if (productForm && this.productForm) {
        HTMLUpdateUtility.viewTransition(this.productForm, productForm, [])
      }
    }

    updatePdpProductContext(html) {
      const pdpProductContext = html.querySelector('pdp-product-context')
      if (pdpProductContext && this.pdpProductContext) {
        HTMLUpdateUtility.viewTransition(this.pdpProductContext, pdpProductContext, [])
      }
    }

    updateProductGalleryFromHtml(html) {
      const productGallery = html.querySelector('product-gallery')
      if (productGallery && this.productGallery) {
        this.productGallery.updateGallery(productGallery)
      }
    }

    updateTallEquivalent(html) {
      const tallEquivalent = html.querySelector('.js-tall-equivalent')
      if (tallEquivalent && this.tallEquivalent) {
        HTMLUpdateUtility.viewTransition(this.tallEquivalent, tallEquivalent, [])
      }
    }

    updateBelowPdpAppContent(html) {
      const belowPdpAppContent = html.querySelector('below-pdp-app-content')
      if (belowPdpAppContent && this.belowPdpAppContent) {
        HTMLUpdateUtility.viewTransition(this.belowPdpAppContent, belowPdpAppContent, [])
      }
    }

    updateVariantInputs(variantId) {
      this.querySelectorAll(`#product-form-v2-${this.dataset.section}`).forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]')
        input.value = variantId ?? ''
        input.dispatchEvent(new Event('change', { bubbles: true }))
      })
    }

    updateURL(url, variantId) {
      if (this.dataset.updateUrl === 'false') return
      this.dataset.url = url
      window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`)
    }

    updateUiFooter(html) {
      const uiFooter = html.querySelector('.js-pdp__ui-footer')
      if (uiFooter && this.uiFooter) {
        HTMLUpdateUtility.viewTransition(this.uiFooter, uiFooter, [])
      }
    }

    updateProductCustomPack(html) {
      const productCustomPack = html.querySelector('product-custom-pack')
      if (productCustomPack && this.productCustomPack) {
        HTMLUpdateUtility.viewTransition(this.productCustomPack, productCustomPack, [])
      }
    }

    updateBxgy(html) {
      const bxgyWrapper = html.querySelector('.js-bxgy-wrapper')
      if (bxgyWrapper && this.bxgyWrapper) {
        HTMLUpdateUtility.viewTransition(this.bxgyWrapper, bxgyWrapper, [])
      }
    }

    updateSizeChartButton(html) {
      const sizeChartButton = html.querySelector('.js-size-chart-button-wrapper')
      if (sizeChartButton && this.sizeChartButton) {
        HTMLUpdateUtility.viewTransition(this.sizeChartButton, sizeChartButton, [])
      }
    }

    updateSizeChartModal(html) {
      const sizeChartModal = html.querySelector('size-chart-modal')
      if (sizeChartModal && this.sizeChartModal) {
        HTMLUpdateUtility.viewTransition(this.sizeChartModal, sizeChartModal, [])
      }
    }

    updateOkendoReviews() {
      const okendoReviews = document.querySelector('okendo-reviews')
      if (okendoReviews) {
        okendoReviews.updateReviews()
      }
    }

    updateProductDescription(html) {
      const productDescription = html.querySelector('.js-product-description')
      if (productDescription && this.productDescription) {
        HTMLUpdateUtility.viewTransition(this.productDescription, productDescription, [])
      }
    }

    buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false, variantId) {
      const params = []
      let finalUrl = url

      // Add /products/ prefix if not already present and not on a product page
      if (!url.includes('/products/') && !window.location.pathname.includes('/products/')) {
        finalUrl = `/products/${url}`
      }

      !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`)

      if (optionValues.length) {
        params.push(`option_values=${optionValues.join(',')}`)
      }

      if (variantId) {
        params.push(`variant=${variantId}`)
      }

      return `${finalUrl}?${params.join('&')}`
    }

    keepSize(productUrl, packSize = this.dataset.productPackSize) {
      let size = this.dataset.selectedSize
      if (!size) return

      let searchKey = `${productUrl}|${size}|${packSize}|`

      if (this.dataset.isVarietyPacks == 'true') {
        size = size.split(' / ')[0]
        searchKey = `${productUrl}|${size}`
      }

      let elementFound;
      if (this.jsonData.curated_packs_data) {
        elementFound = this.jsonData.curated_packs_data.find((variantData) =>
         variantData.startsWith(searchKey),
       )
      }

      if (!elementFound && this.jsonData.singles_data) {
        elementFound = this.jsonData.singles_data.find((single_product) =>
          single_product.startsWith(searchKey),
        )
      }
      if (!elementFound && this.jsonData.families_data) {
        elementFound = this.jsonData.families_data.find((variantData) =>
          variantData.startsWith(searchKey),
        )
      }

      return elementFound?.split('|')[3]
    }

    updateProductPriceFromInputData(target) {
      return;
      const priceWrapper = this.querySelector('.js-product-price')
      if (!priceWrapper) return

      const price = target.dataset.productPrice
      const compareAtPrice = target.dataset.compareAtPrice
      this.dataset.productDiscount = this.calculateDiscount(price, compareAtPrice)

      let priceHtml = ''

      // Only show compare price and discount if there's an actual price difference
      if (compareAtPrice && this.extractPrice(compareAtPrice) > this.extractPrice(price)) {
        priceHtml = `
          <div class="pdp__price pdp__price--full">
            <span class="visually-hidden">Regular price!</span>
            <s>${compareAtPrice}</s>
          </div>

          <div class="pdp__price">
            <span class="visually-hidden">Discounted price</span>
            <span>${price}</span>
          </div>

          <div class="pdp__price-badges">
            <div class="badge">
              <span>Save ${this.calculateDiscount(price, compareAtPrice)}%</span>
            </div>
            ${this.showFreeShippingBadge(this.extractPrice(price)) ? '<div class="badge free-shipping"><span>Free Shipping</span></div>' : ''}
          </div>

          <span class="single-quote">
            <strong>Get up to 3 FREE items below.</strong>
          </span>
          <span class="clearance-quote"><strong>Clearance</strong></span>
        `
      } else {
        priceHtml = `
          <div class="pdp__price">
            <span class="visually-hidden">Price</span>
            <span>${price}</span>
          </div>
          ${this.showFreeShippingBadge(this.extractPrice(price)) ? '<div class="pdp__price-badges"><div class="badge free-shipping"><span>Free Shipping</span></div></div>' : ''}
          <span class="single-quote">
            <strong>Get up to 3 FREE items below.</strong>
          </span>
          <span class="clearance-quote"><strong>Clearance</strong></span>
        `
      }

      priceWrapper.innerHTML = priceHtml
    }

    calculateDiscount(price, compareAtPrice) {
      const priceValue = this.extractPrice(price)
      const compareAtPriceValue = this.extractPrice(compareAtPrice)
      return Math.round(((compareAtPriceValue - priceValue) / compareAtPriceValue) * 100)
    }

    extractPrice(priceString) {
      // Extract numeric value from price string (e.g. "$99.00" -> 99.00)
      return parseFloat(priceString.replace(/[^0-9.]/g, ''))
    }

    showFreeShippingBadge(price) {
      const freeShippingThreshold = parseFloat(this.dataset.freeShippingThreshold || 0)
      return this.dataset.country === 'US' && price >= freeShippingThreshold
    }

    sendDataLayerInfo() {
      const packSize = this.dataset.productPackSize
      window.dataLayer = window.dataLayer || []
      dataLayer.push({ ecommerce: null })
      window.dataLayer.push({
        event: 'view_item',
        cart_source: packSize === 'Single' ? 'PDP Singles' : 'PDP Curated Pack',
        intelligems_meta: window.intelligemsMeta || [],
        membership_status: this.dataset.membershipStatus,
        userId: this.dataset.customerId || null,
        page_type: 'Product Detail Page',
        color_pack: this.dataset.colorPack,
        login_status: this.dataset.loginStatus,
        pdp_type: this.dataset.pdpType,
        pack_quantity: this.dataset.packQuantity,
        ecommerce: {
          currency: this.dataset.ecommerceCurrency,
          value: Number(this.dataset.productPrice),
          items: [
            {
              item_id: Number(this.dataset.productId),
              cart_source: packSize === 'Single' ? 'PDP Singles' : 'PDP Curated Pack',
              item_name: this.dataset.productTitle,
              coupon: '',
              discount: Number(this.dataset.productDiscount),
              index: 1,
              item_brand: this.dataset.productBrand,
              item_category: this.dataset.productCategory,
              item_category2: this.dataset.productCategory2,
              item_category3: Number(this.dataset.productCategory3),
              item_category4: this.dataset.selectedSize,
              item_category5: this.dataset.productCategory5,
              item_list_id: '',
              item_list_name: '',
              item_variant: this.dataset.colorPack,
              price: Number(this.dataset.productPrice),
              quantity: 1,
            },
          ],
        },
      })
    }

    get sectionId() {
      return this.dataset.originalSection || this.dataset.section
    }

    get variantSelectors() {
      return this.querySelector('variant-selects')
    }

    get productColors() {
      return this.querySelector('product-colors')
    }

    get productStyle() {
      return this.querySelector('product-style')
    }

    get productType() {
      return this.querySelector('product-type-selector')
    }

    get packSelectors() {
      return this.querySelector('product-pack-selector')
    }

    get productTitle() {
      return this.querySelector('.js-product-title')
    }

    get productStarRating() {
      return this.querySelector('.js-product-star-rating')
    }

    get productPrice() {
      return this.querySelector('.js-product-price')
    }

    get tallEquivalent() {
      return this.querySelector('.js-tall-equivalent')
    }

    get productForm() {
      return this.querySelector('product-form-v2')
    }

    get productGallery() {
      return this.querySelector('product-gallery')
    }

    get jsonData() {
      const jsonDataContext = this.querySelector('.js-pdp-product-context-json')
      if (!jsonDataContext) return null
      return JSON.parse(jsonDataContext.textContent)
    }

    get selectedSize() {
      return (
        Array.from(this.querySelectorAll('variant-selects input:checked'))
          .map((input) => input.value)
          .join(' / ') || null
      )
    }

    get selectedPackSize() {
      return this.querySelector('product-pack-selector input:checked')?.dataset.size || null
    }

    get insidersPrice() {
      return this.querySelector('.js-insiders-price')
    }

    get belowPdpAppContent() {
      return document.querySelector('below-pdp-app-content')
    }

    get sizeChart() {
      return document.querySelector('#modal-size-chart')
    }

    get monocleProductPrice() {
      const price = this.querySelector('discount-bar .js-monocle-discount-price')
      if (!price) return null
      return price
    }

    get pdpProductContext() {
      return this.querySelector('pdp-product-context')
    }

    get uiFooter() {
      return this.querySelector('.js-pdp__ui-footer')
    }

    get bxgyPrice() {
      return this.querySelector('.js-bxgy-price')
    }

    get bxgyWrapper() {
      return this.querySelector('.js-bxgy-wrapper')
    }

    get productCustomPack() {
      return this.querySelector('product-custom-pack')
    }

    get sizeChartButton() {
      return this.querySelector('.js-size-chart-button-wrapper')
    }

    get sizeChartModal() {
      return this.querySelector('size-chart-modal')
    }

    get productDescription() {
      return this.querySelector('.js-product-description')
    }
  }
  customElements.define('product-info', ProductInfo)
}

if (!customElements.get('discount-bar')) {
  class DiscountBar extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.init()
      this.setupMoncoleCouponAutoApplier()
    }

    init() {
      this.text = this.querySelector('.js-monocle-discount-text')
      this.symbol = this.dataset.currencySymbol
      this.button = this.querySelector('.js-monocle-discount-button')
      this.useMetaobjectPromo = this.dataset.useMetaobjectPromo

      const checkMonocleSDK = setInterval(() => {
        // if useMetaobjectPromo is true, promos.js script handles the discount bar
        const discountBar = document.querySelector('discount-bar')
        const usingMetaobjectPromo = discountBar.dataset.useMetaobjectPromo
        if (usingMetaobjectPromo) {
          clearInterval(checkMonocleSDK)
          return
        }

        if (window.monocleSDK && window.monocleSDK.getOnsiteWidgets()[0]) {
          clearInterval(checkMonocleSDK)
          const couponValue = window.monocleSDK.getOnsiteWidgets()[0].incentiveData.couponValue
          const couponType = window.monocleSDK.getOnsiteWidgets()[0].incentiveData.couponType
          const description = window.monocleSDK.getOnsiteWidgets()[0].description
          const productPrice = Number(document.querySelector('product-info').dataset.productPrice)
          const cashback = Math.round(productPrice * couponValue)
          if (couponType === 'cashback') {
            this.text.innerHTML = `${description} (<span class="js-monocle-discount-price">${this.symbol}${cashback}</span>)`
          } else {
            this.text.innerHTML = `${description} (<span class="js-monocle-discount-price">${this.symbol}${cashback}</span>)`
          }
          this.dataset.couponValue = couponValue
          this.classList.remove('hidden')
          if (this.button) {
            this.button.addEventListener('click', () => {
              const popUp = window.monocleSDK.getOnsiteWidgets()[0]
              if (popUp) popUp.open()
            })
          }
        }
      }, 100)
      window.addEventListener('monocleSDK:incentiveAssigned', this.checkForIncentive.bind(this))
    }

    setupCopyableElements() {
      document.addEventListener('click', (e) => {
        if (e.target.classList.contains('js-monocle-discount-code-copyable')) {
          const text = e.target.textContent
          navigator.clipboard
            .writeText(text)
            .then(() => {
              const originalText = e.target.innerHTML
              e.target.innerHTML = 'Copied!'
              setTimeout(() => {
                e.target.innerHTML = originalText
              }, 1500)
            })
            .catch((err) => {
              console.error('Failed to copy text: ', err)
            })
        }
      })
    }

    async setupMoncoleCouponAutoApplier() {
      function resetPromoButton(button, code) {
        setTimeout(() => {
          button.textContent = code
        }, 1500)
      }

      document.addEventListener('click', async (e) => {
        const button = e.target.closest('.js-monocle-discount-code-autoapplyable')
        if (button) {
          const code = button.textContent
          navigator.clipboard.writeText(code)
          button.textContent = 'Applying...'

          try {
            const response = await fetch(`${window.Shopify.routes.root}discount/${code}`, {
              method: 'GET',
              headers: { 'Content-Type': 'application/json' },
            })

            if (response.ok) {
              button.textContent = 'Applied!'
              resetPromoButton(button, code)
            } else {
              button.textContent = 'Could not apply code.'
              resetPromoButton(button, code)
            }
          } catch (error) {
            console.error('ERR:', error)
            button.textContent = 'Could not apply code.'
            resetPromoButton(button, code)
          }
        }
      })
    }

    async checkForIncentive() {
      const newIncentives = await window.monocleSDK.getIncentives()
      if (newIncentives.length > 0) {
        const incentive = newIncentives[0]
        if (incentive) {
          this.classList.remove('hidden')
          const couponValue = incentive.couponValue
          const couponCode = incentive.couponCode
          const percentage = couponValue * 100
          const productPrice = Number(document.querySelector('product-info').dataset.productPrice)
          const cashback = Math.round(productPrice * couponValue)
          const descriptionLong = incentive.descriptionLong

          if (incentive.couponType === 'cashback') {
            this.text.innerHTML = `${percentage}% Cashback (<span class="js-monocle-discount-price">${this.symbol}${cashback}</span>) Applied`
          } else if (incentive.couponType === 'basic') {
            this.text.innerHTML = `Get ${descriptionLong} w/ code: <button class="js-monocle-discount-code-autoapplyable js-monocle-discount-button">${couponCode}</button>`
          }

          this.button.textContent = incentive.couponCode
          this.button.style.display = 'none'
          this.dataset.couponValue = couponValue
        }
      } else {
        this.classList.remove('hidden')
      }
    }
  }
  customElements.define('discount-bar', DiscountBar)
}

if (!customElements.get('klaviyo-notify-me')) {
  class KlaviyoNotifyMe extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.init()
    }

    init() {
      this.form = this.querySelector('form')
      this.button = this.querySelector('button')
      this.emailInput = this.querySelector('input')
      this.successMessage = this.querySelector('.js-success-message')
      this.form.addEventListener('submit', async (event) => {
        event.preventDefault()

        this.button.classList.add('loading')
        this.emailInput.setAttribute('disabled', true)
        this.querySelector('.loading__spinner').classList.remove('hidden')

        const email = this.emailInput.value.trim()
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

        if (!emailRegex.test(email)) {
          this.emailInput.setCustomValidity('Please enter a valid email address')
          this.emailInput.reportValidity()
          return
        }

        this.emailInput.setCustomValidity('')

        const variantId = this.form.querySelector('input[name="variant_id"]').value
        const options = {
          method: 'POST',
          headers: {
            accept: 'application/json',
            revision: '2024-06-15',
            'content-type': 'application/json',
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: `${email}`,
                    },
                  },
                },
                channels: ['EMAIL'],
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: `$shopify:::$default:::${variantId}`,
                  },
                },
              },
            },
          }),
        }

        const response = await fetch(
          'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=Lj2344',
          options,
        )
        if (response) {
          this.successMessage.classList.remove('visually-hidden')
          this.form.classList.add('visually-hidden')
        }
        this.button.classList.remove('loading')
        this.emailInput.removeAttribute('disabled')
        this.querySelector('.loading__spinner').classList.add('hidden')
      })

      // Add input validation on email changes
      this.emailInput.addEventListener('input', () => {
        const email = this.emailInput.value.trim()
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

        if (!emailRegex.test(email)) {
          this.button.setAttribute('disabled', true)
          this.emailInput.setCustomValidity('Please enter a valid email address')
        } else {
          this.button.removeAttribute('disabled')
          this.emailInput.setCustomValidity('')
        }
      })
    }
  }
  customElements.define('klaviyo-notify-me', KlaviyoNotifyMe)
}

if (!customElements.get('sticky-add-to-cart')) {
  class StickyAddToCart extends HTMLElement {
    constructor() {
      super()
      this.observer = null
      this.mutationObserver = null
      this.productForm = null
    }

    connectedCallback() {
      this.init()
      this.setupMutationObserver()
    }

    setupMutationObserver() {
      this.mutationObserver = new MutationObserver((mutations) => {
        // Check if the product form was removed and re-added
        const productForm = document.querySelector('product-form-v2')
        if (productForm !== this.productForm) {
          this.cleanupObserver()
          this.init()
        }
      })

      // Observe the entire document for changes to product-form
      this.mutationObserver.observe(document.body, {
        childList: true,
        subtree: true,
      })
    }

    cleanupObserver() {
      if (this.observer) {
        this.observer.disconnect()
        this.observer = null
      }
    }

    init() {
      this.productForm = document.querySelector('product-form-v2')
      if (!this.productForm) return

      this.button = this.querySelector('button')
      this.button.addEventListener('click', () => {
        const targetElement = document.querySelector('product-type-selector')
        const selectedVariant = document.querySelector('variant-selects input:checked')
        if (targetElement) {
          const offsetTop = targetElement.getBoundingClientRect().top + window.scrollY - 87
          targetElement.scrollIntoView({ top: offsetTop, behavior: 'smooth' })

          if (selectedVariant) {
            document.querySelector('product-form-v2 button[type="submit"]').click()
          }
        }
      })

      // Set up the Intersection Observer
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              this.classList.remove('hidden')
            } else {
              this.classList.add('hidden')
            }
          })
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 0,
        },
      )

      // Start observing the product form
      this.observer.observe(this.productForm)
    }

    disconnectedCallback() {
      // Clean up both observers when the element is removed
      this.cleanupObserver()
      if (this.mutationObserver) {
        this.mutationObserver.disconnect()
        this.mutationObserver = null
      }
    }
  }
  customElements.define('sticky-add-to-cart', StickyAddToCart)
}

// if (!customElements.get('bundle-cart-count')) {
//   class BundleCartCount extends HTMLElement {
//     constructor() {
//       super()
//     }

//     connectedCallback() {
//       this.init()
//     }

//     init() {
//       const button = this.querySelector('button')
//       if (!button) return
//       button.addEventListener('click', () => {
//         document.querySelector('#mini-cart-open')?.click()
//       })
//     }
//   }
//   customElements.define('bundle-cart-count', BundleCartCount)
// }

if (!customElements.get('product-custom-pack')) {
  class ProductCustomPack extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.addToBundle = this.querySelector('[name="add-item-to-bundle"]')
      this.addBundleToCart = this.querySelector('[name="add-bundle-to-cart"]')

      if (this.addToBundle !== null) {
        this.addToBundle.addEventListener('click', (event) => {
          const selectedCheckbox = this.querySelector('input:checked')
          const featuredImage = selectedCheckbox.dataset.featuredImage
          const variantId = selectedCheckbox.dataset.variantId
          console.log(`Add item ${variantId} to bundle`)
          const cartItem = this.querySelector('.pdp__custom-pack-cart-item:not(.selected)')
          cartItem.setAttribute('data-variant-id', variantId)
          cartItem.style.backgroundImage = `url(${featuredImage})`
          cartItem.classList.add('selected')
        })
      }

      if (this.addBundleToCart !== null) {
        this.addBundleToCart.addEventListener('click', (event) => {
          console.log('Add bundle to cart')

          let formData = {
            items: [
              {
                id: 40592815030344,
                quantity: 1,
                properties: {
                  _variantIds: '29275989082184x7<>29275946877000x5',
                },
              },
            ],
          }

          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
          })
            .then((response) => {
              return response.json()
            })
            .catch((error) => {
              console.error('Error:', error)
            })
        })
      }
    }
  }
  customElements.define('product-custom-pack', ProductCustomPack)
}

if (!customElements.get('open-size-chart')) {
  class OpenSizeChart extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.init()
    }

    init() {
      this.addEventListener('click', () => {
        const sizeChartModal = document.querySelector('size-chart-modal')
        if (sizeChartModal) {
          sizeChartModal.open()
        }
      })
    }
  }
  customElements.define('open-size-chart', OpenSizeChart)
}

if (!customElements.get('open-compare-modal')) {
  class OpenCompareModal extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.init()
    }

    init() {
      this.addEventListener('click', () => {
        const compareModal = document.querySelector('compare-modal')
        if (compareModal) {
          compareModal.open()
        }
      })
    }
  }
  customElements.define('open-compare-modal', OpenCompareModal)
}

/**
 *
 * GLOBALS (Replace this on the new theme)
 *
 */

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  }
}

function handleNotReturningSwatches() {
  const first_color = document.querySelector('product-colors input')
  const product_color = document.querySelector('product-colors input:checked')
  if (!first_color || !product_color) return

  if (product_color.dataset.notReturning === 'true' && product_color.dataset.disabled === 'true') {
    first_color.click()
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * Uses View Transitions API where supported, falls back to double buffer approach.
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    // Process the new content
    preProcessCallbacks?.forEach((callback) => callback(newContent))

    const newNodeWrapper = document.createElement('div')
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML)
    const newNode = newNodeWrapper.firstChild

    // Dedupe IDs
    const uniqueKey = Date.now()
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && element.setAttribute('id', `${element.id}-${uniqueKey}`)
      element.form &&
        element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`)
    })

    // Insert new node and hide old one
    oldNode.parentNode.insertBefore(newNode, oldNode)
    oldNode.style.display = 'none'

    // Run post-process callbacks
    postProcessCallbacks?.forEach((callback) => callback(newNode))

    // Remove old node after transition
    setTimeout(() => oldNode.remove(), 50)
  }

  // Sets inner HTML and reinjects the script tags to allow execution
  static setInnerHTML(element, html) {
    element.innerHTML = html
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script')
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value)
      })
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML))
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag)
    })
  }
}

// Handle update of Insider Upsell on cart changes
window.addEventListener('DOMContentLoaded', () => {
  handleNotReturningSwatches()

  function dataLayerPageView() {
    const productInfo = document.querySelector('product-info')
    if (!productInfo) return
    const packSize = productInfo.dataset.productPackSize
    window.dataLayer = window.dataLayer || []
    dataLayer.push({ ecommerce: null })
    window.dataLayer.push({
      event: 'view_item',
      cart_source: packSize === 'Single' ? 'PDP Singles' : 'PDP Curated Pack',
      membership_status: productInfo.dataset.membershipStatus,
      intelligems_meta: window.intelligemsMeta || {},
      userId: productInfo.dataset.customerId || null,
      page_type: 'Product Detail Page',
      color_pack: productInfo.dataset.colorPack,
      login_status: productInfo.dataset.loginStatus,
      pdp_type: productInfo.dataset.pdpType,
      pack_quantity: productInfo.dataset.packQuantity,
      ecommerce: {
        currency: productInfo.dataset.ecommerceCurrency,
        value: Number(productInfo.dataset.productPrice),
        items: [
          {
            item_id: Number(productInfo.dataset.productId),
            cart_source: packSize === 'Single' ? 'PDP Singles' : 'PDP Curated Pack',
            item_name: productInfo.dataset.productTitle,
            coupon: '',
            discount: Number(productInfo.dataset.productDiscount),
            index: 1,
            item_brand: productInfo.dataset.productBrand,
            item_category: productInfo.dataset.productCategory,
            item_category2: productInfo.dataset.productCategory2,
            item_category3: Number(productInfo.dataset.productCategory3),
            item_category4: productInfo.dataset.selectedSize,
            item_category5: productInfo.dataset.productCategory5,
            item_list_id: '',
            item_list_name: '',
            item_variant: productInfo.dataset.colorPack,
            price: Number(productInfo.dataset.productPrice),
            quantity: 1,
          },
        ],
      },
    })
  }
  // dataLayerPageView() Remove comment when React pdp is removed

  document.addEventListener('cartaddsuccess', handleCartUpdate)
  document.addEventListener('cartremovesuccess', handleCartUpdate)
  document.addEventListener('cartupdatesuccess', handleCartUpdate)
  document.addEventListener('cartmembershipaddsuccess', handleCartUpdate)

  async function handleCartUpdate() {
    const productInfo = document.querySelector('product-info')
    if (!productInfo) return

    const sectionId = productInfo.dataset.section
    if (!sectionId) return

    try {
      const response = await fetch(
        `${window.location.pathname}?section_id=${sectionId}&view=pdp-liquid`,
      )
      const htmlSection = await response.text()
      const html = new DOMParser().parseFromString(htmlSection, 'text/html')
      updateInsiderClubUpsell(html)
      updateBxgy(html)
    } catch (e) {
      console.error(e)
    }
  }

  function updateInsiderClubUpsell(html) {
    const insiderUpsell = html.querySelector('.js-insider-club-upsell')
    const current = document.querySelector('.js-insider-club-upsell')
    if (insiderUpsell && current) {
      HTMLUpdateUtility.viewTransition(current, insiderUpsell, [])
    }
  }

  function updateBxgy(html) {
    const bxgy = html.querySelector('.js-bxgy-wrapper')
    const current = document.querySelector('.js-bxgy-wrapper')
    if (bxgy && current) {
      HTMLUpdateUtility.viewTransition(current, bxgy, [])
    }
  }
})


window.addEventListener('DOMContentLoaded', async () => {
  const globalContextId = 'global-context-json'
  let previousCart = await fetchCart();

  document.addEventListener('cartaddsuccess', async () => {
    await updateGlobalContextOnCartChange();
    const newCart = await fetchCart();
    if (!newCart || !newCart.items.length) return;
    previousCart = newCart;
  });

  document.addEventListener('cartremovesuccess', async () => {
    await updateGlobalContextOnCartChange();
    const newCart = await fetchCart();
    if (!newCart) return;
    previousCart = newCart;
  })

  document.addEventListener('cartupdatesuccess', async () => {
    await updateGlobalContextOnCartChange();
    const newCart = await fetchCart();
    if (!newCart) return;
    previousCart = newCart;
  });

  getGlobalContext()

  async function fetchCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      const cartDataElement = document.querySelector('.js-mini-cart #cart-data');
      if (cartDataElement) {
        const cartData = JSON.parse(cartDataElement.textContent);
        cart.items.forEach((item, index) => {
          if (cartData.items[index]) {
            item.metafields = cartData.items[index].metafields;
          }
        });
      }
      return cart;

    } catch (error) {
      console.error('Error fetching cart:', error);
      return null;
    }
  }

  async function updateGlobalContextOnCartChange() {
    const jsonData = await fetchGlobalContextJSON()
    updateGlobalContextJSON(jsonData)
  }

  async function fetchGlobalContextJSON() {
    const response = await fetch(`${Shopify.routes}?section_id=${globalContextId}`)
    const htmlSection = await response.text()
    const parser = new DOMParser()
    const responseDoc = parser.parseFromString(htmlSection, 'text/html')
    const scriptContent = responseDoc.querySelector(`script#${globalContextId}`)?.textContent
    if (scriptContent) {
      return JSON.parse(scriptContent)
    } else {
      console.error('cannot find global context')
    }
  }

  function updateGlobalContextJSON(jsonData) {
    const globalJSONParent = document.querySelector(`#shopify-section-${globalContextId}`)
    if (globalJSONParent) {
      const script = globalJSONParent.querySelector(`script#${globalContextId}`)
      script.textContent = JSON.stringify(jsonData)
    }
  }

  function getGlobalContext() {
    const globalContext = document.querySelector(`script#${globalContextId}`)?.textContent;
    return globalContext ? JSON.parse(globalContext) : null;
  }
})